<div class="account_security_step">
  <app-set-password
    [passwordState]="stepAccount.passwordState"
    [stepAccount]="stepAccount"
    (passwordChanged)="passwordChanged()"
  ></app-set-password>
  <hr />
  <app-security-question [qna]="stepAccount.qna" (qnaChanged)="qnaChanged()"></app-security-question>
</div>
